import { render } from "./DiscussionModal.vue?vue&type=template&id=726e0970&scoped=true"
import script from "./DiscussionModal.vue?vue&type=script&lang=js"
export * from "./DiscussionModal.vue?vue&type=script&lang=js"

import "./DiscussionModal.vue?vue&type=style&index=0&id=726e0970&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726e0970"]])

export default __exports__